import { selectVariant } from "./selectVariant";

import {
  COMBINED,
  TWO_SIDES, 
  STENCIL_TOP_SIDE,
  oneItemStencilTypes 
} from "../data/StencilsConstants";

const getParametersToPreserve = (parameters) => {
  return Object.keys(parameters).filter((key) => key !== 'stencil_side').map((key) => {
    return {key, value: parameters[key]}
  });
}

export const preserveStencilsParameters = (state, prevStencilSide, prevStencils) => {
  if(!prevStencilSide || !prevStencils) return;

  if((prevStencilSide === COMBINED && state.stencilsSide === TWO_SIDES)){
    getParametersToPreserve(prevStencils[0].parameters).forEach(({key, value}) => {
      state.stencils[0].parameters[key] = value;
      state.stencils[1].parameters[key] = value;
    })
    state.stencils[0].variant = selectVariant(state.stencils[0].parameters, state.stencils[0].product.variants);
    state.stencils[1].variant = selectVariant(state.stencils[1].parameters, state.stencils[1].product.variants);
    return;
  }

  let prevStencilIndex = 0;
  let currentStencilIndex = 0;

  if(prevStencilSide === TWO_SIDES && state.stencilsSide === COMBINED){
    prevStencilIndex = prevStencils.findIndex((s) => s.parameters.stencil_side === STENCIL_TOP_SIDE);
  }

  if(oneItemStencilTypes.includes(prevStencilSide) && state.stencilsSide === 'both'){
    currentStencilIndex = state.stencils.findIndex((s) => s.parameters.stencil_side === prevStencils[0].parameters.stencil_side);
  }

  if(prevStencilSide === 'both' && oneItemStencilTypes.includes(state.stencilsSide)){
    prevStencilIndex = prevStencils.findIndex((s) => s.parameters.stencil_side === state.stencils[0].parameters.stencil_side);
  }

  getParametersToPreserve(prevStencils[prevStencilIndex].parameters).forEach(({key, value}) => {
    state.stencils[currentStencilIndex].parameters[key] = value;
  })
  state.stencils[currentStencilIndex].variant = selectVariant(state.stencils[currentStencilIndex].parameters, state.stencils[currentStencilIndex].product.variants);
}